var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Arrow Right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Privacy-Center",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-State-Result",
    transform: "translate(-363, -4216)",
    fill: "#003046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Primary-/-Default--Copy-2",
    transform: "translate(347, 4207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16, 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Arrow-Right",
    transform: "translate(4.1, 3.85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05,12.75 L2.05,15.25 L13.75,15.25 L13.75,12.75 L15.8,12.75 L15.8,17.3 L14.15,17.3 L0,17.3 L0,12.75 L2.05,12.75 Z M8.925,4.4408921e-16 L8.925,9.791 L13.2689364,5.45325096 L14.7156854,6.9 L7.9,13.7156854 L1.08431458,6.9 L2.53106361,5.45325096 L6.875,9.792 L6.875,4.4408921e-16 L8.925,4.4408921e-16 Z",
    id: "Fill"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadButton);
export default __webpack_public_path__ + "static/media/downloadButton.828ae080a91d676b00cf77debc559752.svg";
export { ForwardRef as ReactComponent };